import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
import api from '@/api'
import { mdiMinusCircleOutline, mdiPlus, mdiTrophyOutline } from '@mdi/js'

import BKUserSelect from '@/components/BKUserSelect.vue'
import { ModalWrapper } from '@/shared/ui/modals'
import BKOrganizationSelect from '@/components/BKOrganizationSelect.vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { getDateFormattedForPicker } from '@/services/date'
import { VueEditor } from 'vue2-editor'
import { BattleDB, BracketLevel, BracketLevelName, CapTypeBattle, useBattle } from '@/enitites/battle'
import { computed, onMounted, ref, watch } from 'vue'
import { UserDB } from '@/enitites/user'
import { CheckboxInput } from '@/shared/ui/inputs'
import BKCheckbox from '@/components/AppShared/BKCheckbox.vue'
import BKEditorConfig from '../../../common/vue2Config'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventAddBattle',
  props: {
    isShowModal: { type: Boolean },
    isEditMode: { type: Boolean },
    battleId: null
  },
  emits: ["update:isShowModal", "updateBattle"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:isShowModal', value: boolean): void
  (e: 'updateBattle', value: BattleDB): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isShowModal: boolean
  isEditMode: boolean
  battleId: number
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const { battleCategories, battlePlaces } = useBattle()




const battle = ref<null | BattleDB>(null)
const categories = battleCategories
const existingPlaces = battlePlaces
const createBtnLoading = ref(false)
const battleStyles = ['bracket', 'classic']
const error = ref<string | null>(null)
const dateForPicker = ref<string | null>(null)
const bracketSizes = [32, 16, 8, 4, 2]
const availableRounds = Array.from(Array(101).keys()).map((n) => n + 1)
const editorConfig = BKEditorConfig
const getUserDB = computed(() => store.getters.getUserDB)
const isShowBtnAddPlace = computed(() => battle.value?.prizes.length !== existingPlaces.length)

function handleCapTypeSelecting(capType: CapTypeBattle) {
  if (!battle.value) return

  if (battle.value.participationCapType === capType) {
    battle.value.participationCapType = 'none'
    battle.value.limit = 0
  } else {
    battle.value.participationCapType = capType
  }
}

watch(
  () => battle.value?.hideParticipants,
  () => {
    if (!battle.value) return
    if (battle.value.hideParticipants && battle.value.participationCapType === 'registration') {
      battle.value.participationCapType = 'none'
      battle.value.limit = 0
    }
  }
)

async function updateBattle() {
  if (!battle.value || !dateForPicker.value) return
  createBtnLoading.value = true
  battle.value.startDate = new Date(dateForPicker.value.replace(/-/g, '/'))
  const fetchedBattle = await api.battles.update(battle.value)
  if (!fetchedBattle) {
    error.value = 'Something went wrong. Please try again later.'
    createBtnLoading.value = false
    emit('update:isShowModal', false)
    return
  }
  createBtnLoading.value = false
  emit('update:isShowModal', false)
  emit('updateBattle', fetchedBattle)
}

function addPlaceToBattle() {
  if (!battle.value) return
  battle.value.prizes = [
    ...battle.value.prizes,
    {
      id: existingPlaces[battle.value.prizes.length].id,
      title: existingPlaces[battle.value.prizes.length].title,
      amount: 0,
    },
  ]
}

function setLevels() {
  const battleValue = battle.value
  if (!battleValue) return

  const levelsMax = bracketSizes
    .slice()
    .reverse()
    .findIndex((s) => s === battleValue.bracketSize)
  battleValue.bracketLevels = []

  if (battleValue.bracketSize === 2) {
    battleValue.bracketLevels.push({
      name: 'Final',
      rounds: 1,
    })

    return
  }

  for (let i = 0; i < levelsMax; i++) {
    const level: BracketLevel = {
      name:
        i === battleValue.bracketLevels.length - 1
          ? 'Semi-final'
          : (`Top ${bracketSizes.filter((size) => size <= battleValue.bracketSize)[i]}` as BracketLevelName),
      rounds: 1,
    }

    battleValue.bracketLevels.push(level)
  }

  battleValue.bracketLevels.push({
    name: 'Final',
    rounds: 1,
  })
}

function handlerClickDeletePlace() {
  if (!battle.value) return
  battle.value.prizes.pop()
}

function updateShowModal(evt: boolean) {
  emit('update:isShowModal', evt)
}

async function addBattleRole(user: UserDB, role: string) {
  if (!battle.value) return
  const updatedRoles = await api.battles.addRole(battle.value.id, user.id, role)
  if (updatedRoles) battle.value.judges = updatedRoles
}

async function removeBattleRole(user: UserDB, role: string) {
  if (!battle.value) return
  const updatedRoles = await api.battles.removeRole(battle.value.id, user.id, role)
  if (updatedRoles) battle.value.judges = updatedRoles
}

function setPlacePrize(placeId: number) {
  if (!battle.value) return
  const place = battle.value.prizes.find((placeItem) => placeItem.id === placeId)
  if (!place) return
  place.amount = Math.abs(place.amount)
  if (place.amount > 0 && place.amount < 1) place.amount = 1
}

onMounted(async () => {
  battle.value = await api.battles.getBattle(props.battleId)
  if (!battle.value) return
  dateForPicker.value = getDateFormattedForPicker(battle.value.startDate)
  if (!battle.value.prizes.length) addPlaceToBattle()
  if (!battle.value.bracketLevels.length) setLevels()
})

return { __sfc: true,battleCategories, battlePlaces, props, emit, battle, categories, existingPlaces, createBtnLoading, battleStyles, error, dateForPicker, bracketSizes, availableRounds, editorConfig, getUserDB, isShowBtnAddPlace, handleCapTypeSelecting, updateBattle, addPlaceToBattle, setLevels, handlerClickDeletePlace, updateShowModal, addBattleRole, removeBattleRole, setPlacePrize, mdiMinusCircleOutline, mdiPlus, mdiTrophyOutline, BKUserSelect, ModalWrapper, BKOrganizationSelect, VueEditor, CheckboxInput, BKCheckbox }
}

})